import { IsBoolean, IsNumber, IsOptional, IsString } from 'class-validator';
import { TreasuryTransactionTypeEnum } from '@up/data';

export class TreasuryBankingTransactionRequestDto {
  @IsNumber()
  businessEntityId: number;

  @IsNumber()
  @IsOptional()
  businessEntityBankId?: number;

  @IsString()
  @IsOptional()
  fromDate?: Date | string;

  @IsString()
  @IsOptional()
  toDate?: Date | string;

  @IsString()
  @IsOptional()
  description?: string;

  @IsString()
  @IsOptional()
  transactionType?: TreasuryTransactionTypeEnum | undefined;

  @IsNumber()
  @IsOptional()
  page?: number;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsBoolean()
  @IsOptional()
  updateBalance?: boolean;

  @IsBoolean()
  @IsOptional()
  updateTransactions?: boolean;
}
